import api from "@/api/api";

export interface Config {
  copyright: string;
  com_plan_hvname?: string;
  com_plan_fendt_name?: string;
  com_plan_valtra_name?: string;
  app_locked?: boolean;
  app_locked_message?: string;
}

class ConfigService {
  async getAgcoConfig(): Promise<Config> {
    const response = await api.get("/agco-config");
    return response.data;
  }
}

export default new ConfigService();
